<li class="list-item btn">
    <h4>{{item.id}} : {{item.speed}}  /{{#each item.loc}} {{.}} /{{/each}}</h4>
    <h5>{{item.locDate}}</h5>
</li>
